export function createRpcCall<Params>({
  method,
  params,
  id,
}: {
  method: string;
  params: Params[];
  id: number;
}): string {
  return JSON.stringify({
    jsonrpc: '2.0',
    method,
    params,
    id,
  });
}
